import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

const COPY = {
  weekly: "You won't get any more weekly season emails. Your receipts, your Coach Ready access and the newsletter aren't affected.",
  progress: "You won't get any more Coach Ready progress emails. Your receipts, your Coach Ready access and the newsletter aren't affected.",
};

export default function CoachReadyUnsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const series = params.get("series") === "progress" ? "progress" : "weekly";
  const [state, setState] = useState("busy");
  useEffect(() => {
    api.post("/coach-ready/emails/unsubscribe", { token, series }).then(() => setState("done")).catch(() => setState("error"));
  }, [token, series]);
  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="cr-unsub-page">
      <h1 className="font-head font-semibold uppercase text-3xl text-[#1E1E1E]">
        {state === "error" ? "This link isn't valid" : state === "done" ? "You're unsubscribed" : "One moment..."}
      </h1>
      {state === "done" && <p className="mt-3 text-[#3A3A3A]" data-testid="cr-unsub-done">{COPY[series]}</p>}
      {state === "done" && series === "weekly" && (
        <p className="mt-4 text-sm text-[#6E6E6E]">Changed your mind? <Link to={`/coach-ready/season?token=${token}`} className="underline" data-testid="cr-unsub-resubscribe">Set your first-practice date</Link> to start them again.</p>
      )}
      {state === "error" && <p className="mt-3 text-[#3A3A3A]" data-testid="cr-unsub-error">Use the link at the bottom of your latest Coach Ready email.</p>}
    </div>
  );
}
